export const TABS_DICTIONARY = {
  SETUP: '#testSetup',
  RESPONSE: '#response',
  BUNDLE: '#bundle',
  HTTP: '#http',
  CONSOLE: '#console',
};

export enum SETUP_TYPES {
  pretty = 'Pretty',
  raw = 'Raw',
}

export const SETUP_TAB = {
  text: 'Test Setup',
  href: TABS_DICTIONARY.SETUP,
};
